import React, { useEffect, useState } from "react";
import { CircularProgress, Alert } from "@mui/material";
import DevicesTableBase from "./DevicesTableBase";
import { useDevices } from "../../hooks/useDevices";

export default function OrganisationDevicesTable(props) {
  const { data: devices = [], isLoading, error } = useDevices();

  const [filteredDevices, setFilteredDevices] = useState([]);

  //convert string to int for organisation id
  const organisationID = parseInt(props.organisationID);

  useEffect(() => {
    let mounted = true;

    if (mounted && devices.length) {
      let filtered = devices.filter((device) => {
        return device["organisation_id"] === organisationID;
      });

      setFilteredDevices(filtered);
    }
  }, [devices, props.organisationID]);

  if (isLoading) {
    return <CircularProgress />;
  }

  if (error) {
    return (
      <Alert severity="error">Error loading devices: {error.message}</Alert>
    );
  }

  return (
    <DevicesTableBase
      title="Organisation Devices"
      devices={filteredDevices}
      orderby="time_updated"
    />
  );
}
